<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
    <div class="shunyi-person-page">
    <!-- 个人信息卡片 -->
    <div class="user-info-card">
      <!-- 左侧头像区 -->
      <div class="avatar-section">
        <div class="user-avatar">
          <van-icon name="user-circle-o" size="70" color="#4A90E2"/>
        </div>
      </div>

      <!-- 右侧信息区 -->
      <div class="info-section">
        <div class="name-line">
          <span class="user-name">{{ displayName }}</span>
          <span class="user-gender" v-if="displayGender">{{ displayGender }}</span>
        </div>

        <div class="info-line">
          <span class="label">手机号码:</span>
          <span class="value">{{ displayPhone || '--' }}</span>
        </div>

      </div>
    </div>

    <!-- 功能按钮 -->
    <div class="action-section">
      <div class="action-buttons">
        <div class="action-button" @click="contactService">
          <van-icon name="service-o" size="20" />
          <span>联系康复助理</span>
          <van-icon name="arrow" class="arrow-icon" />
        </div>
        <div class="action-button action-button--payment" v-if="isLogin" @click="goToPaymentRecords">
          <van-icon name="balance-pay" size="20" />
          <span>缴费记录查询</span>
          <van-icon name="arrow" class="arrow-icon" />
        </div>
      </div>
    </div>

    <!-- 康复服务卡片 -->
    <div v-if="isLogin" class="service-card">
      <div class="service-card__header">
        <van-icon name="service-o" size="18" color="#4A90E2" />
        <span class="service-card__title">康复服务</span>
      </div>
      <div v-if="isVipLoading" class="service-card__loading">
        <van-loading color="#4A90E2" size="16">加载中...</van-loading>
      </div>
      <div v-else-if="vipInfo" class="service-card__content">
        <div class="service-card__info">
          <div class="service-card__item">
            <span class="service-card__label">服务有效期</span>
            <span class="service-card__value">{{ formatVipExpireDate(vipInfo.endTime) }}</span>
          </div>
          <div class="service-card__item">
            <span class="service-card__label">剩余天数</span>
            <span class="service-card__value service-card__value--highlight">{{ remainingDays }}天</span>
          </div>
        </div>
      </div>
      <div v-else class="service-card__empty">
        <span class="service-card__empty-text">暂无康复服务</span>
      </div>
    </div>

    <!-- 训练视频播放统计 -->
    <div class="training-stats-section" v-if="isLogin">
      <div class="stats-header">
        <div>
        <h3 class="stats-title">训练统计</h3>
        <span class="stats-title-tip" style="font-size: 12px; color: #999999;;">训练方案、视频播放记录</span>
      </div>
        <van-icon
          name="replay"
          class="stats-refresh"
          @click="refreshStats"
          :class="{ 'stats-refresh--loading': loading }"
        />
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="stats-loading">
        <van-loading color="#4A90E2" size="24">加载中...</van-loading>
      </div>

      <!-- 空状态 -->
      <div v-else-if="!myCourses.length" class="stats-empty">
        <van-icon name="video-o" size="40" color="#d4d8de" />
        <p class="empty-text">暂无训练记录</p>
        <p class="empty-tip">开始您的康复训练之旅吧</p>
      </div>

      <!-- 统计数据 -->
      <div v-else class="stats-content">
        <div class="stats-summary">
          <div class="summary-item">
            <div class="summary-value">{{ planCount }}</div>
            <div class="summary-label">方案数</div>
          </div>
          <div class="summary-item">
            <div class="summary-value">{{ watchedPlanCount }}</div>
            <div class="summary-label">已观看方案数</div>
          </div>
          <div class="summary-item">
            <div class="summary-value">{{ videoCount }}</div>
            <div class="summary-label">已观看视频数</div>
          </div>
          <div class="summary-item">
            <div class="summary-value">{{ totalPlanProgress }}%</div>
            <div class="summary-label">全部方案完成度</div>
          </div>
        </div>

        <!-- 训练时长和最近训练统计 -->
        <div class="duration-stats">
          <div class="duration-title">训练时长</div>
          <div class="duration-grid">
            <div class="duration-item">
              <div class="duration-label">今天</div>
              <div class="duration-value">{{ formatDuration(todayDuration) }}</div>
            </div>
            <div class="duration-item">
              <div class="duration-label">昨天</div>
              <div class="duration-value">{{ formatDuration(yesterdayDuration) }}</div>
            </div>
            <div class="duration-item">
              <div class="duration-label">本周</div>
              <div class="duration-value">{{ formatDuration(weekDuration) }}</div>
            </div>
            <div class="duration-item">
              <div class="duration-label">最近训练</div>
              <div class="duration-value">{{ recentDays }}</div>
            </div>
          </div>
        </div>

        <!-- 最近观看列表 -->
        <div class="recent-list">
          <div class="recent-title">最近训练</div>
          <div
            class="recent-item"
            v-for="item in recentCourses"
            :key="item.id"
            @click="goToCourseDetail(item)"
          >
            <div class="recent-cover" :style="{ backgroundImage: 'url(' + item.cover + ')' }">
              <div class="recent-tag" v-if="item.vipOnly">VIP</div>
            </div>
            <div class="recent-info">
              <div class="recent-plan-title" v-if="item.planTitle">
                方案：{{ item.planTitle }}
              </div>
              <div class="plan-progress" v-if="item.planProgress !== undefined && item.planProgress !== null">方案完成度：{{ item.planProgress }}%</div>
              <div class="recent-name">{{ item.title }}</div>
              <div class="recent-time">{{ formatWatchTime(item.lastWatchTime) }}</div>
              <van-progress
                :percentage="item.progress"
                stroke-width="4"
                color="#4A90E2"
                track-color="#E3F2FD"
              />
            </div>
            <van-icon name="arrow" class="recent-arrow" />
          </div>
        </div>
      </div>
    </div>

    <div class="test-login-section">
      <van-button
        block
        type="info"
        icon="user-o"
        class="test-login-button"
        @click="handleTestLogin"
      >
        快速体验
      </van-button>
    </div>
  </div>
  </van-pull-refresh>
</template>

<script>
import { Dialog } from 'vant'
import TicaoDao from '@/h5/doucan/network/Ticao.js'
import PlanDao from '@/h5/doucan/network/PlanDao.js'
import VipDao from '@/h5/doucan/network/VipDao.js'
import imgCoverDefaultPlan from '@/h5/doucan/assets/shunyi/img_cover_default_plan.png'

export default {
  name: 'ShunyiPerson',
  components: {},
  data () {
    return {
      isHideTitle: false,
      userGender: '', // 用户性别
      thirdPartyUserId: '', // 第三方系统用户ID
      userName: '', // 用户姓名
      userPhone: '', // 用户电话
      myCourses: [], // 我的训练课程列表（去重后的）
      allWatchRecords: [], // 所有播放记录（未去重，用于统计时长）
      myPlanList: [], // 我的训练方案列表
      loading: false, // 加载状态
      loadingPlanList: false, // 加载方案列表状态
      refreshing: false, // 下拉刷新状态
      vipInfo: null, // VIP信息
      isVipLoading: false // VIP加载状态
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.profile.isLogin
    },
    userInfo () {
      return this.$store.state.user.profile || {}
    },
    displayName () {
      return this.userName || this.userInfo.name || '未登录用户'
    },
    displayGender () {
      const gender = this.userGender || this.userInfo.gender
      if (gender === '男' || gender === 'male' || gender === 'M') return '男'
      if (gender === '女' || gender === 'female' || gender === 'F') return '女'
      return ''
    },
    displayPhone () {
      return this.userPhone || this.userInfo.phone || ''
    },
    displayUserId () {
      return this.thirdPartyUserId || ''
    },
    genderClass () {
      const gender = this.displayGender
      if (gender === '男') return 'gender-male'
      if (gender === '女') return 'gender-female'
      return ''
    },
    // 方案数（从训练方案列表接口获取）
    planCount () {
      return this.myPlanList.length
    },
    // 已观看方案数（从播放记录中统计不同的 planId）
    watchedPlanCount () {
      if (!this.myCourses.length) return 0
      const planIds = new Set()
      this.myCourses.forEach(item => {
        if (item.planId) {
          planIds.add(item.planId)
        }
      })
      return planIds.size
    },
    // 已观看视频数（统计不同的 planCourseId 数量，如果没有则使用总数）
    videoCount () {
      if (!this.myCourses.length) return 0
      const courseIds = new Set()
      this.myCourses.forEach(item => {
        if (item.planCourseId) {
          courseIds.add(item.planCourseId)
        } else if (item.id) {
          courseIds.add(item.id)
        }
      })
      return courseIds.size || this.myCourses.length
    },
    // 最近训练天数
    recentDays () {
      if (!this.myCourses.length) return 0
      const latestTime = Math.max(...this.myCourses.map(c => c.lastWatchTime || 0))
      if (!latestTime) return 0
      const days = Math.floor((Date.now() - latestTime) / (1000 * 60 * 60 * 24))
      if (days === 0) return '今天'
      if (days === 1) return '昨天'
      return `${days}天前`
    },
    // 全部方案完成度（计算所有方案的平均完成度，未观看的方案记为0%）
    totalPlanProgress () {
      // 如果没有方案列表，返回 0
      if (!this.myPlanList.length) return 0

      // 先从播放记录中提取每个方案的进度（按 planId 分组，取最高的 planProgress）
      const planProgressMap = new Map()
      this.myCourses.forEach(item => {
        if (item.planId && item.planProgress !== undefined && item.planProgress !== null) {
          const currentProgress = Number(item.planProgress) || 0
          const existedProgress = planProgressMap.get(item.planId) || 0
          if (currentProgress > existedProgress) {
            planProgressMap.set(item.planId, currentProgress)
          }
        }
      })

      // 遍历所有方案，计算总进度
      // 每个方案如果有观看记录则使用记录进度，没有则记为0%
      let totalProgress = 0

      this.myPlanList.forEach(planItem => {
        // 从 planItem 中获取 planId（planItem.id 就是方案ID）
        const planId = planItem.id
        if (planId) {
          // 如果该方案有观看记录，使用记录的进度；否则使用0%
          const progress = planProgressMap.get(planId) || 0
          totalProgress += progress
        }
      })

      // 计算平均完成度：总进度 / 方案总数
      return Math.round(totalProgress / this.myPlanList.length)
    },
    // 今天的训练时长（秒）
    todayDuration () {
      if (!this.allWatchRecords.length) return 0
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const todayStart = today.getTime()

      return this.allWatchRecords.reduce((total, record) => {
        const watchTime = record.watchTime || 0
        if (watchTime >= todayStart) {
          return total + (record.onlineDuration || 0)
        }
        return total
      }, 0)
    },
    // 昨天的训练时长（秒）
    yesterdayDuration () {
      if (!this.allWatchRecords.length) return 0
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const yesterdayStart = today.getTime() - 24 * 60 * 60 * 1000
      const yesterdayEnd = today.getTime()

      return this.allWatchRecords.reduce((total, record) => {
        const watchTime = record.watchTime || 0
        if (watchTime >= yesterdayStart && watchTime < yesterdayEnd) {
          return total + (record.onlineDuration || 0)
        }
        return total
      }, 0)
    },
    // 本周的训练时长（秒）
    weekDuration () {
      if (!this.allWatchRecords.length) return 0
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      // 获取本周一的时间
      const dayOfWeek = today.getDay()
      const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
      const weekStart = today.getTime() - daysToMonday * 24 * 60 * 60 * 1000

      return this.allWatchRecords.reduce((total, record) => {
        const watchTime = record.watchTime || 0
        if (watchTime >= weekStart) {
          return total + (record.onlineDuration || 0)
        }
        return total
      }, 0)
    },
    // 最近观看的课程（同一方案只保留最近一条，最多显示3个）
    recentCourses () {
      if (!this.myCourses.length) return []
      const planIdToLatestItem = new Map()
      this.myCourses.forEach(item => {
        const key = item.planId || `noplan_${item.id}`
        const existed = planIdToLatestItem.get(key)
        const currentTs = item.lastWatchTime || 0
        const existedTs = existed ? (existed.lastWatchTime || 0) : 0
        if (!existed || currentTs > existedTs) {
          planIdToLatestItem.set(key, item)
        }
      })
      const list = Array.from(planIdToLatestItem.values())
      list.sort((a, b) => (b.lastWatchTime || 0) - (a.lastWatchTime || 0))
      return list.slice(0, 3)
    },
    // 是否为VIP
    isVip () {
      return !!this.vipInfo
    },
    // 剩余天数
    remainingDays () {
      if (!this.vipInfo || !this.vipInfo.endTime) return 0
      try {
        // 处理时间戳（兼容秒和毫秒）
        const normalizeTimestamp = (ts) => {
          if (!ts) return 0
          const num = Number(ts)
          return num < 1e12 ? num * 1000 : num
        }

        const endTime = normalizeTimestamp(this.vipInfo.endTime)
        const now = Date.now()
        const diff = endTime - now
        if (diff <= 0) return 0
        const days = Math.ceil(diff / (1000 * 60 * 60 * 24))
        return days
      } catch (error) {
        console.error('计算剩余天数失败:', error)
        return 0
      }
    }
  },
  mounted () {
    const query = this.$route.query

    console.log('个人中心页面参数:', query)

    if (query.from === 'wxapp') {
      this.isHideTitle = true
    }

    // 优先从 URL 参数获取用户信息，如果没有则从 sessionStorage 读取
    this.userGender = query.gender || sessionStorage.getItem('shunyi_user_gender') || ''
    this.thirdPartyUserId = query.userId || sessionStorage.getItem('shunyi_user_id') || ''
    this.userName = query.name || sessionStorage.getItem('shunyi_user_name') || ''
    this.userPhone = query.phone || sessionStorage.getItem('shunyi_user_phone') || ''

    console.log('用户信息:', {
      name: this.userName,
      gender: this.userGender,
      phone: this.userPhone,
      userId: this.thirdPartyUserId
    })

    // 如果已登录，加载训练方案列表和视频统计数据
    if (this.isLogin) {
      this.loadPlanList()
      this.loadMyCourses()
      this.fetchVipInfo()
    }
  },
  methods: {
    handleLogin () {
      this.$router.push('/login/index')
    },
    handleTestLogin () {
      this.$router.push({
        path: '/Shunyi/home',
        query: {
          hospitalId: 'shunyi001',
          hospitalName: '暨南大学附属顺德医院',
          phone: '13800138000',
          name: '王星月',
          gender: '女',
          userId: 'USER123456'
        }
      })
    },
    handleLogout () {
      Dialog.confirm({
        title: '确认',
        message: '确定要退出登录吗？'
      }).then(() => {
        // 清除登录状态
        this.$store.commit('user/logout')
        this.$toast.success('已退出登录')
      }).catch(() => {
        // 取消操作
      })
    },
    contactService () {
      Dialog.alert({
        title: '联系康复助理',
        message: '电话或微信联系\n18520535303',
        confirmButtonText: '我知道了',
        confirmButtonColor: '#4A90E2'
      })
    },
    // 加载我的训练方案列表
    async loadPlanList () {
      if (!this.isLogin) {
        return
      }

      try {
        this.loadingPlanList = true
        const phone = this.userPhone || this.$store.state.user.profile.phone
        if (!phone) {
          console.warn('加载方案列表失败：缺少手机号')
          this.myPlanList = []
          return
        }

        console.log('加载训练方案列表, phone:', phone)
        const data = await PlanDao.loadList(phone)
        console.log('训练方案列表数据:', data)

        if (data && Array.isArray(data)) {
          this.myPlanList = data
        } else {
          console.warn('训练方案列表数据格式异常:', data)
          this.myPlanList = []
        }
      } catch (error) {
        console.error('加载训练方案列表失败:', error)
        this.myPlanList = []
      } finally {
        this.loadingPlanList = false
      }
    },
    // 加载我的训练课程数据
    async loadMyCourses () {
      if (!this.isLogin) {
        return
      }

      try {
        this.loading = true
        // 优先使用 URL/会话中的第三方或注册后的 userId，避免沿用 H5 历史登录
        const userId = (this.$route.query && this.$route.query.userId) || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId
        console.log('加载训练视频统计, userId:', userId)

        const data = await TicaoDao.listAppletMyPlan(userId)
        console.log('训练视频数据:', data)

        if (data && Array.isArray(data)) {
          // 保存原始数据（未去重，用于统计时长）
          this.allWatchRecords = data.map(item => ({
            ...item,
            onlineDuration: Number(item.onlineDuration) || 0, // 在线时长（秒）
            watchTime: this.normalizeTimestamp(item.gmtModified || item.gmtCreate) // 观看时间
          }))

          // 按 planCourseId 去重，保留最新的 gmtModified（用于显示）
          const courseMap = new Map()
          data.forEach(item => {
            const courseKey = item.planCourseId || `${item.planId}_${item.id}`
            const lastWatchTs = this.normalizeTimestamp(item.gmtModified || item.gmtCreate)
            const existed = courseMap.get(courseKey)
            if (!existed || lastWatchTs > this.normalizeTimestamp(existed.gmtModified || existed.gmtCreate)) {
              courseMap.set(courseKey, item)
            }
          })

          // 数据映射 - 适配新的数据结构
          this.myCourses = Array.from(courseMap.values()).map(item => ({
            ...item,
            // 使用 planCourseId 作为唯一标识，如果没有则使用组合键
            id: item.planCourseId || `${item.planId}_${item.id}`,
            // 使用 planCourseTitle 作为标题，如果没有则使用 planTitle
            title: item.planCourseTitle || item.planTitle || '未知课程',
            // 封面图片使用默认值（新数据结构中没有封面字段）
            cover: item.coverUrl || item.detailUrl || item.cover || imgCoverDefaultPlan,
            // 单视频进度百分比（取整）
            progress: Number(item.progress) || 0,
            // 训练方案进度百分比（取整）
            planProgress: Number(item.planProgress) || 0,
            // VIP标识暂时设为false（新数据结构中没有此字段）
            vipOnly: !!item.vip,
            // 使用 gmtModified 作为最后观看时间，如果没有则使用 gmtCreate
            lastWatchTime: this.normalizeTimestamp(item.gmtModified || item.gmtCreate),
            // 保留原有字段以便后续使用
            planId: item.planId,
            planTitle: item.planTitle,
            planCourseId: item.planCourseId,
            planCourseTitle: item.planCourseTitle
          }))

          // 按最后播放时间倒序排列
          this.myCourses.sort((a, b) => (b.lastWatchTime || 0) - (a.lastWatchTime || 0))
        } else {
          console.warn('训练视频数据格式异常:', data)
          this.myCourses = []
        }
      } catch (error) {
        console.error('加载训练视频统计失败:', error)
        this.$toast('加载训练数据失败')
        this.myCourses = []
      } finally {
        this.loading = false
      }
    },
    // 下拉刷新
    async onRefresh () {
      if (!this.isLogin) {
        this.refreshing = false
        return
      }
      try {
        await Promise.all([
          this.loadPlanList(),
          this.loadMyCourses(),
          this.fetchVipInfo()
        ])
        this.$toast.success('刷新成功')
      } catch (error) {
        console.error('刷新失败:', error)
        this.$toast('刷新失败')
      } finally {
        this.refreshing = false
      }
    },
    // 刷新统计数据
    async refreshStats () {
      if (this.loading) return
      console.log('刷新训练统计')
      await Promise.all([
        this.loadPlanList(),
        this.loadMyCourses()
      ])
      this.$toast.success('刷新成功')
    },
    // 时间戳标准化（兼容秒/毫秒）
    normalizeTimestamp (val) {
      const num = Number(val)
      if (!num || isNaN(num)) return 0
      return num < 1e12 ? num * 1000 : num
    },
    // 格式化时长（秒转分钟或小时，不足一分钟按1分钟计算）
    formatDuration (seconds) {
      if (!seconds || seconds === 0) return '0分钟'
      // 不足一分钟按1分钟计算（向上取整）
      const totalMinutes = Math.ceil(seconds / 60)
      if (totalMinutes < 60) {
        return `${totalMinutes}分钟`
      }
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60
      if (minutes === 0) {
        return `${hours}小时`
      }
      return `${hours}小时${minutes}分钟`
    },
    // 格式化观看时间
    formatWatchTime (watchTime) {
      if (!watchTime) return '暂无记录'

      try {
        const date = new Date(watchTime)
        const now = new Date()

        // 判断是否为今天
        const isToday = date.toDateString() === now.toDateString()
        if (isToday) {
          return `今天 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        }

        // 判断是否为昨天
        const yesterday = new Date(now)
        yesterday.setDate(yesterday.getDate() - 1)
        const isYesterday = date.toDateString() === yesterday.toDateString()
        if (isYesterday) {
          return `昨天 ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
        }

        // 格式：月-日 时:分
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')

        return `${month}-${day} ${hours}:${minutes}`
      } catch (error) {
        console.error('日期格式化失败:', error)
        return '格式错误'
      }
    },
    // 跳转到课程详情
    goToCourseDetail (item) {
      console.log('查看课程详情:', item)
      // 新数据结构使用 planId 跳转到训练方案详情页
      if (item.planId) {
        const phone = this.$store.state.user.profile.phone || ''
        this.$router.push({
          path: '/PlanDetailPage',
          query: {
            planId: item.planId,
            phone: phone,
            from: 'wxapp'
          }
        })
      } else {
        // 兼容旧数据结构，跳转到康复课程详情页
        this.$router.push({
          name: 'RehabCourseDetail',
          query: {
            id: item.id
          }
        })
      }
    },
    // 获取VIP信息
    async fetchVipInfo () {
      if (!this.isLogin) {
        this.isVipLoading = false
        return
      }

      try {
        this.isVipLoading = true
        const userId = (this.$route.query && this.$route.query.userId) || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId
        console.log('获取VIP信息, userId:', userId)

        if (!userId) {
          console.warn('获取VIP信息失败：缺少用户ID')
          this.vipInfo = null
          this.isVipLoading = false
          return
        }

        const vipInfo = await VipDao.getUserVipInfo(userId)
        console.log('VIP信息结果:', vipInfo)
        if (vipInfo) {
          this.vipInfo = vipInfo
          console.log('设置vipInfo成功:', this.vipInfo)
        } else {
          this.vipInfo = null
          console.log('vipInfo为null')
        }
      } catch (error) {
        console.error('获取VIP信息失败:', error)
        this.vipInfo = null
      } finally {
        this.isVipLoading = false
      }
    },
    // 格式化VIP到期日期
    formatVipExpireDate (endTime) {
      if (!endTime) return ''
      try {
        // 处理时间戳（兼容秒和毫秒）
        const normalizeTimestamp = (ts) => {
          if (!ts) return 0
          const num = Number(ts)
          return num < 1e12 ? num * 1000 : num
        }

        const timestamp = normalizeTimestamp(endTime)
        const date = new Date(timestamp)
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        return `${year}-${month}-${day}`
      } catch (error) {
        console.error('格式化VIP到期日期失败:', error)
        return ''
      }
    },
    // 跳转到缴费记录查询页面
    goToPaymentRecords () {
      const userId = (this.$route.query && this.$route.query.userId) || sessionStorage.getItem('shunyi_user_id') || this.$store.state.user.profile.userId
      this.$router.push({
        path: '/ShunyiPaymentRecords',
        query: {
          userId: userId,
          from: 'wxapp'
        }
      })
    }
  }
}
</script>

<style scoped>
/* 页面背景 */
.shunyi-person-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #E8F5FD 0%, #F5F7FA 100%);
  padding: 16px;
}

/* 个人信息卡片 - 左右布局 */
.user-info-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
}

/* 左侧头像区 */
.avatar-section {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.user-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ffffff;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.15);
  margin-bottom: 8px;
}

.verify-badge {
  background: #FFF3E0;
  color: #F57C00;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 12px;
  font-weight: 500;
  border: 1px solid #FFE0B2;
}

/* 右侧信息区 */
.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
}

.name-line {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}

.user-name {
  font-size: 22px;
  font-weight: 600;
  color: #1A1A1A;
  line-height: 1.3;
}

.user-gender {
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}

.vip-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #F5F5F5;
  transition: all 0.3s ease;
}

.vip-badge--active {
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border: 1px solid #FFB74D;
}

.vip-text {
  font-size: 12px;
  font-weight: 500;
  color: #999999;
}

.vip-badge--active .vip-text {
  color: #FF6B35;
}

.vip-expire-line {
  margin-top: 4px;
}

.vip-expire {
  color: #FF6B35;
  font-weight: 500;
}

.info-line {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.6;
}

.info-line .label {
  color: #999999;
  margin-right: 8px;
  min-width: 72px;
}

.info-line .value {
  color: #333333;
  font-weight: 500;
}

/* 功能按钮区域 */
.action-section {
  margin-bottom: 16px;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.action-buttons .action-button {
  flex: 1;
  padding: 16px 12px;
  font-size: 15px;
}

.action-button--payment {
  background: linear-gradient(180deg, #59a8ff 0%, #2b7de8 100%);
  box-shadow: 0 4px 12px rgba(43, 125, 232, 0.2);
}

/* 康复服务卡片 */
.service-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.service-card__header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.service-card__title {
  font-size: 15px;
  font-weight: 600;
  color: #1A1A1A;
}

.service-card__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}

.service-card__content {
  padding-top: 4px;
}

.service-card__info {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-card__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  background: #F8FBFF;
  border-radius: 6px;
}

.service-card__label {
  font-size: 13px;
  color: #666666;
}

.service-card__value {
  font-size: 13px;
  font-weight: 500;
  color: #333333;
}

.service-card__value--highlight {
  color: #4A90E2;
  font-weight: 600;
  font-size: 15px;
}

.service-card__empty {
  text-align: center;
  padding: 12px 0;
  color: #999999;
}

.service-card__empty-text {
  font-size: 13px;
}

.action-button {
  background: linear-gradient(135deg, #4A90E2 0%, #5BA3E8 100%);
  border-radius: 12px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 12px rgba(74, 144, 226, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
}

.action-button:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(74, 144, 226, 0.25);
}

.arrow-icon {
  margin-left: auto;
  font-size: 16px;
  opacity: 0.8;
}

.test-login-section {
  margin-top: 16px;
  padding-bottom: 20px;
}

.test-login-button {
  height: 44px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  background: linear-gradient(135deg, #4A90E2 0%, #2b7de8 100%);
  box-shadow: 0 4px 12px rgba(43, 125, 232, 0.2);
}

/* 训练视频播放统计 */
.training-stats-section {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.stats-title {
  font-size: 18px;
  font-weight: 600;
  color: #1A1A1A;
  margin: 0;
}

.stats-refresh {
  font-size: 20px;
  color: #4A90E2;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.stats-refresh:active {
  transform: scale(0.9);
}

.stats-refresh--loading {
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 加载状态 */
.stats-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

/* 空状态 */
.stats-empty {
  text-align: center;
  padding: 40px 20px;
  color: #999999;
}

.empty-text {
  font-size: 16px;
  color: #646566;
  margin: 12px 0 4px;
}

.empty-tip {
  font-size: 13px;
  color: #969799;
  margin: 0;
}

/* 统计摘要 */
.stats-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #F0F0F0;
  margin-bottom: 20px;
}

.summary-item {
  text-align: center;
}

.summary-value {
  font-size: 24px;
  font-weight: 600;
  color: #4A90E2;
  line-height: 1.2;
  margin-bottom: 6px;
}

.summary-label {
  font-size: 12px;
  color: #999999;
  line-height: 1.4;
  word-break: keep-all;
  white-space: nowrap;
}

/* 训练时长统计 */
.duration-stats {
  margin-top: 20px;
  padding-top: 20px;
}

.duration-title {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
}

.duration-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.duration-item {
  text-align: center;
  padding: 12px;
  background: #F8FBFF;
  border-radius: 8px;
}

.duration-label {
  font-size: 12px;
  color: #999999;
  margin-bottom: 6px;
}

.duration-value {
  font-size: 16px;
  font-weight: 600;
  color: #4A90E2;
}

/* 最近观看列表 */
.recent-list {
  margin-top: 16px;
}

.recent-title {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
}

.recent-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #F8FBFF;
  border-radius: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.recent-item:last-child {
  margin-bottom: 0;
}

.recent-item:active {
  transform: scale(0.98);
  background: #F0F8FF;
}

.recent-cover {
  width: 80px;
  height: 60px;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
  position: relative;
}

.recent-tag {
  position: absolute;
  top: 4px;
  left: 4px;
  background: linear-gradient(135deg, #ff8f3f 0%, #ff5b2e 100%);
  color: #ffffff;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
}

.recent-info {
  flex: 1;
  min-width: 0;
}

.recent-plan-title {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-bottom: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}

.plan-progress {
  color: #4A90E2;
  flex-shrink: 0;
  font-size: 12px;
}

.recent-name {
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-time {
  font-size: 12px;
  color: #4A90E2;
  margin-bottom: 6px;
}

.recent-arrow {
  color: #999999;
  font-size: 16px;
  flex-shrink: 0;
}

/* 响应式优化 */
@media (max-width: 360px) {
  .user-avatar {
    width: 80px;
    height: 80px;
  }

  .user-name {
    font-size: 20px;
  }

  .info-line {
    font-size: 13px;
  }

  .recent-cover {
    width: 70px;
    height: 50px;
  }

  .summary-value {
    font-size: 20px;
  }
}
</style>
